import React from "react";
import Modal from "../";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  setVisible,
  setTitle,
  setDescription,
} from "../../../store/slices/premiumTrial";

export default function PremiumTrial() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { visible, title, description } = useSelector(
    (state) => state.premiumTrial
  );

  const handleClose = () => {
    dispatch(setVisible(false));
  };

  const handleAfterClose = () => {
    dispatch(setTitle(""));
    dispatch(setDescription(""));
  };

  const handlePremium = () => {
    navigate("/premium");
    handleClose();
  };

  return (
    <Modal
      visible={visible}
      handleClose={handleClose}
      handleAfterClose={handleAfterClose}
    >
      <div className="rounded-lg w-full bg-white p-4 shadow-lg">
        <div className="flex flex-col items-center justify-between">
          <div className="relative h-28 w-full flex justify-center items-center">
            <div className="absolute h-52 w-52 -top-28">
              <img
                src={require("../../../assets/images/layout/coracaoChave.png")}
                alt="keyHeart"
                className="h-full w-full object-contain relative -left-3"
              />
            </div>
            <div className="relative -top-full left-1/2">
              <div className="absolute -left-5">
                <div className="flex justify-center items-center w-8 h-8 rounded-full bg-[#52525280]">
                  <button onClick={handleClose} className="touchable-opacity">
                    <IoMdClose color="white" size={26} />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h1 className="text-[#FF4F4F] text-center text-2xl leading-7 font-black mb-4">
              {title}
            </h1>

            <p className="text-center text-[#BD8127] text-base leading-5 font-bold">
              {description}
            </p>
          </div>
          <button
            type="button"
            onClick={handlePremium}
            className="btn rounded-full btn-small pt-2 pb-2 w-full text-center font-bold text-2xl bg-[#DEB972]"
          >
            {t("bePremium")}
          </button>
        </div>
      </div>
    </Modal>
  );
}
